var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 0.293C14.5195 0.105529 14.2652 0.000213623 14 0.000213623C13.7348 0.000213623 13.4805 0.105529 13.293 0.293L11 2.586L9.707 1.293C9.51947 1.10553 9.26516 1.00021 9 1.00021C8.73484 1.00021 8.48053 1.10553 8.293 1.293L2.293 7.293C2.11084 7.4816 2.01005 7.7342 2.01233 7.9964C2.0146 8.2586 2.11977 8.50941 2.30518 8.69482C2.49059 8.88023 2.7414 8.9854 3.0036 8.98767C3.2658 8.98995 3.5184 8.88916 3.707 8.707L9 3.414L9.586 4L7.293 6.293L0.293 13.293C0.105451 13.4805 5.66374e-05 13.7348 0 14V18C0 18.2652 0.105357 18.5196 0.292893 18.7071C0.48043 18.8946 0.734784 19 1 19H5C5.26519 18.9999 5.51951 18.8946 5.707 18.707L12.707 11.707L18.707 5.707C18.8945 5.51947 18.9998 5.26516 18.9998 5C18.9998 4.73484 18.8945 4.48053 18.707 4.293L14.707 0.293ZM11.707 4.707L14 2.414L16.586 5L12 9.586L9.414 7L11.707 4.707ZM2 14.414L8 8.414L10.586 11L4.586 17H2V14.414Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck1);
export default __webpack_public_path__ + "static/media/check_1.ae66724ae0321ac98fb3a950f34af647.svg";
export { ForwardRef as ReactComponent };